import { fetchDataFromBackend } from "../api/api";
import { PaidOvertimeDTO } from "../DTOs/paidOvertimeDTO";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

function generateSimulatedPaidOvertime(userId, count = 5) {
    const entries = [];
    for (let i = 1; i <= count; i++) {
        entries.push(
            new PaidOvertimeDTO({
                id: i,
                userId: userId,
                userName: `User ${userId}`,
                organizationId: "org-sim",
                date: new Date(2026, 2, i).toISOString(),
                hours: Math.floor(Math.random() * 5),
                minutes: Math.floor(Math.random() * 60),
                comment: `Simulated overtime entry ${i}`,
                createdAt: new Date().toISOString(),
                createdBy: "admin@sim.com",
            })
        );
    }
    return entries;
}

export const PaidOvertimeService = {
    async getByUser(userId) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Generating paid overtime for user", userId);
                return generateSimulatedPaidOvertime(userId);
            }
            logger.log("Fetching paid overtime for user:", userId);
            const response = await fetchDataFromBackend(`/api/PaidOvertime/user/${userId}`, { method: 'get' });
            return response.map(item => new PaidOvertimeDTO(item));
        } catch (error) {
            logger.error("Error getting paid overtime by user:", error);
            throw error;
        }
    },

    async getByOrganisation(orgId) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Generating paid overtime for org", orgId);
                return generateSimulatedPaidOvertime(1, 10);
            }
            logger.log("Fetching paid overtime for organisation:", orgId);
            const response = await fetchDataFromBackend(`/api/PaidOvertime/organisation/${orgId}`, { method: 'get' });
            return response.map(item => new PaidOvertimeDTO(item));
        } catch (error) {
            logger.error("Error getting paid overtime by organisation:", error);
            throw error;
        }
    },

    async getMyOvertime() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Generating my paid overtime");
                return generateSimulatedPaidOvertime(1, 3);
            }
            logger.log("Fetching my paid overtime (secure endpoint)");
            const response = await fetchDataFromBackend('/MyPaidOvertime/GetMyPaidOvertime', { method: 'get' });
            return response.map(item => new PaidOvertimeDTO(item));
        } catch (error) {
            logger.error("Error getting my paid overtime:", error);
            throw error;
        }
    },

    async create(data) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Creating paid overtime", data);
                return new PaidOvertimeDTO({ ...data, id: Date.now(), createdAt: new Date().toISOString() });
            }
            logger.log("Creating paid overtime entry");
            const response = await fetchDataFromBackend(`/api/PaidOvertime`, { method: 'post', data });
            return new PaidOvertimeDTO(response);
        } catch (error) {
            logger.error("Error creating paid overtime:", error);
            throw error;
        }
    },

    async update(id, data) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Updating paid overtime", id);
                return;
            }
            logger.log("Updating paid overtime entry:", id);
            await fetchDataFromBackend(`/api/PaidOvertime/${id}`, { method: 'put', data });
        } catch (error) {
            logger.error("Error updating paid overtime:", error);
            throw error;
        }
    },

    async delete(id) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode: Deleting paid overtime", id);
                return;
            }
            logger.log("Deleting paid overtime entry:", id);
            await fetchDataFromBackend(`/api/PaidOvertime/${id}`, { method: 'delete' });
        } catch (error) {
            logger.error("Error deleting paid overtime:", error);
            throw error;
        }
    },
};
